import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

/**
 * Bottom fade + bouncing chevron shown only when a scrollable container
 * (see useScrollOverflow) has more content below the fold. Disappears once
 * the user scrolls to the bottom.
 */
export function ScrollHintFade({ show, testid, className = "", fadeColor = "black" }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className={`pointer-events-none absolute bottom-0 inset-x-0 h-24 flex items-end justify-center pb-2 ${className}`}
          style={{ background: `linear-gradient(to top, ${fadeColor}, transparent)` }}
          data-testid={testid}
        >
          <motion.div
            animate={{ y: [0, 6, 0] }}
            transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
            className="flex flex-col items-center gap-0.5 text-zinc-500"
          >
            <ChevronDown size={16} />
            <span className="font-mono text-[9px] tracking-[0.2em] uppercase">Scroll</span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
